import { render, staticRenderFns } from "./ValueDifference.vue?vue&type=template&id=4067ecff&"
import script from "./ValueDifference.vue?vue&type=script&lang=js&"
export * from "./ValueDifference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports